import { Link } from "react-router-dom";
import "./activity-slot.styles.css";

const ActivitySlot = ({ activitySlotDetail }) => {
  return (
    <div className="timelist bg-primary activity-slot-container">
      <div>

      <h3 className="label-batch text-warning activity-slot-batch">
        {activitySlotDetail.batchNames || activitySlotDetail.batchName}
      </h3>
      <h4 className="label-topic activity-slot-topic">{activitySlotDetail.topicName}</h4>
      <p className="label-room activity-slot-time">
        {activitySlotDetail.roomName} [{activitySlotDetail.startTime} -{" "}
        {activitySlotDetail.endTime}]
      </p>
      </div>
      <span >

      {/* <Link style={{color: "var(--danger)"}} to={"/"}>Open attendance</Link> */}
      </span>
    </div>
  );
};

export default ActivitySlot
